import FactsHexagon from '@backrs_ui/common-ui/src/assets/images/facts-hexagon.svg';

import { SxProps, Theme, Typography, Box } from '@mui/material';
import ReactMarkdown from 'react-markdown';

import { ImageCard } from './ImageCard';
import { appStrings } from '../assets/appStrings';
import { CareerQuestionFacts } from '../models/careerPath';

const STRINGS = appStrings.modules.blueprint;

export type FactCardProps = Readonly<{
  facts: CareerQuestionFacts[];
}>;

export function FactCard({ facts }: FactCardProps) {
  const factsSection = (
    <Box sx={factsContainerSx}>
      {facts.map((info, index) => (
        <ReactMarkdown
          key={index}
          components={{
            p: ({ children }) => (
              <Typography
                key={index}
                component="p"
                sx={info.type === 'LINK' ? urlTextStyle : {}}
                onClick={info.type === 'LINK' ? () => window.open(info.url, '_blank') : undefined}
                variant="text-sm-regular"
              >
                {children}
              </Typography>
            ),
          }}
        >
          {info.value}
        </ReactMarkdown>
      ))}
    </Box>
  );

  return (
    <ImageCard
      imageUrl={FactsHexagon}
      title={STRINGS.didYouKnow}
      description={factsSection}
      sxOverrides={{
        container,
        imageWrapper,
        title,
        titleDescChildContainer,
        image,
      }}
    />
  );
}

const factsContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
  paddingTop: backrs.spacing['spacing-xs'],
});

const imageWrapper: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Error/400'],
  padding: backrs.spacing['spacing-3xl'],
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderBottom: `1px solid ${backrs.colors['Colors/Base/Black']}`,
});

const title: SxProps<Theme> = ({ backrs, typography }) => ({
  ...typography['text-sm-medium'],
  color: backrs.colors['Colors/Text/text-secondary'],
});

const container: SxProps<Theme> = {
  '&:hover': {
    boxShadow: 'none',
    transform: 'none',
  },
  cursor: 'default',
  '@media (max-width: 600px)': {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderBottom: 'none',
  },
};

const titleDescChildContainer: SxProps<Theme> = ({ backrs }) => ({
  padding: backrs.spacing['spacing-3xl'],
  '@media (max-width: 600px)': {
    paddingBottom: backrs.spacing['spacing-9xl'],
  },
});

const image: SxProps<Theme> = {
  width: '100%',
  '@media (max-width: 600px)': {
    width: '210px',
  },
};

const urlTextStyle: SxProps<Theme> = {
  cursor: 'pointer',
  textDecoration: 'underline',
} as const;
